import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Stack,
  Typography,
  InputLabel,
} from "@mui/material";
import { FC } from "react";
import { GROUPED_OPTIONS } from "./constants/groupedOptions";
import { CollectionType } from "../../apis/bacchus/collections";

interface Props {
  type: CollectionType | "all";
  setType: (type: CollectionType | "all") => void;
  enableAllOption?: boolean;
  dataTestId?: string;
}

export const CollectionTypeSelect: FC<Props> = ({
  type,
  setType,
  enableAllOption,
  dataTestId,
}) => {
  return (
    <Box width="200px">
      <FormControl fullWidth variant="standard">
        <InputLabel>Type</InputLabel>
        <Select
          data-testid={dataTestId}
          variant="standard"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          {enableAllOption && <MenuItem value="all">All</MenuItem>}
          {GROUPED_OPTIONS.map((group) => {
            return [
              <Stack
                key={group.header}
                direction="row"
                alignItems="center"
                spacing={1}
                bgcolor="#ebebeb"
                padding="1px 5px"
                margin="5px"
                borderRadius="10px"
              >
                {group.icon}
                <Typography variant="overline"> {group.header}</Typography>
              </Stack>,
              ...group.options.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{ paddingLeft: 4 }}
                >
                  {option.label}
                </MenuItem>
              )),
            ];
          })}
        </Select>
      </FormControl>
    </Box>
  );
};
